module.exports = __webpack_public_path__ + "static/media/pinkSofa.458172ea.svg";